module.exports = ".modal-header{border:none}.modal-footer{border:none}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/policies/policies-list/remove-policy-modal/remove-policy-modal.component.scss
// module id = ./src/app/access-management/policies/policies-list/remove-policy-modal/remove-policy-modal.component.scss
// module chunks = access-management.module